import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card mb-[25px]" }
const _hoisted_2 = {
  class: "trezo-card-content relative",
  id: "cryptocurrencyWatchlistSlides"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BitcoinChart = _resolveComponent("BitcoinChart")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_EthereumChart = _resolveComponent("EthereumChart")!
  const _component_SolanaChart = _resolveComponent("SolanaChart")!
  const _component_BinanceChart = _resolveComponent("BinanceChart")!
  const _component_CardanoChart = _resolveComponent("CardanoChart")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Cryptocurrency Watchlist")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swiper, {
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1536: {
            slidesPerView: 4,
          },
        },
        modules: _ctx.modules,
        class: "mySwiper"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SwiperSlide, null, {
            default: _withCtx(() => [
              _createVNode(_component_BitcoinChart)
            ]),
            _: 1
          }),
          _createVNode(_component_SwiperSlide, null, {
            default: _withCtx(() => [
              _createVNode(_component_EthereumChart)
            ]),
            _: 1
          }),
          _createVNode(_component_SwiperSlide, null, {
            default: _withCtx(() => [
              _createVNode(_component_SolanaChart)
            ]),
            _: 1
          }),
          _createVNode(_component_SwiperSlide, null, {
            default: _withCtx(() => [
              _createVNode(_component_BinanceChart)
            ]),
            _: 1
          }),
          _createVNode(_component_SwiperSlide, null, {
            default: _withCtx(() => [
              _createVNode(_component_CardanoChart)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modules"]),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"swiper-button-box\"><div class=\"swiper-button-prev\"><i class=\"ri-arrow-left-s-line\"></i></div><div class=\"swiper-button-next\"><i class=\"ri-arrow-right-s-line\"></i></div></div>", 1))
    ])
  ]))
}